"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decryptAesPayload = decryptAesPayload;
exports.decryptVerifyCodePayload = decryptVerifyCodePayload;
var _cryptoJs = _interopRequireDefault(require("crypto-js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var KEY = _cryptoJs.default.enc.Utf8.parse('YxkjVerifyCodeKy');
var IV = _cryptoJs.default.enc.Utf8.parse('YxkjVerifyCodeIv');

/**
 * AES-CBC 解密接口 data（与后端 AesPayloadCryptoUtil 一致）。
 * 若已是对象/数组（未加密兼容），直接返回。
 */
function decryptAesPayload(cipherText) {
  if (cipherText == null || cipherText === '') {
    throw new Error('密文为空');
  }
  if (_typeof(cipherText) === 'object') {
    return cipherText;
  }
  if (typeof cipherText !== 'string') {
    throw new Error('响应格式异常');
  }
  var decrypted = _cryptoJs.default.AES.decrypt({
    ciphertext: _cryptoJs.default.enc.Base64.parse(cipherText)
  }, KEY, {
    iv: IV,
    mode: _cryptoJs.default.mode.CBC,
    padding: _cryptoJs.default.pad.Pkcs7
  });
  var plainText = decrypted.toString(_cryptoJs.default.enc.Utf8);
  if (!plainText) {
    throw new Error('响应解密失败');
  }
  return JSON.parse(plainText);
}

/** @deprecated 使用 decryptAesPayload */
function decryptVerifyCodePayload(cipherText) {
  return decryptAesPayload(cipherText);
}